import request from '@/utils/request'
import qs from 'qs'

export const getCountNumber = () => {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countNumber',
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getNew() {
    return new request({
        url: './vulnerability/vulnerabilityInfos/getNew6',
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getHotBug() {
    return new request({
        url: './vulnerability/vulnerabilityInfos/getTop10',
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getBugLine() {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countTenMonth',
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getBugPie() {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countClass',
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getBugPieTwo() {
    return new request({
        url: './vulnerability/vulnerabilityInfos/countGrade',
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getBugInfo(id) {
    return new request({
        url: './vulnerability/vulnerabilityInfos/'+id,
        method: 'get',
        headers:{
            type:'index',
        }
    });
}
export function getHotMsg(params) {
    return new request({
        url: './article/articleInfos/getNew6',
        method: 'get',
        params:params,
        headers:{
            type:'index',
        }
    });
}